import { useCallback } from "react";
import useMarkInboxReviewed from "./useMarkInboxReviewed";

/**
 * "This document is dealt with" — the landing every processing action
 * shares. Attaching a piece of evidence to a work item IS processing
 * the document, so the surfaces that do it (desktop AIPane, MobileInbox)
 * call this afterwards instead of leaving the reader to click Mark
 * reviewed as separate bookkeeping: mark reviewed, reconcile the unread
 * badge, advance to the next unread document, backfill the page — the
 * exact same landing the footer's Mark reviewed button gives.
 *
 * An already-reviewed document (reading in "show reviewed" mode) is a
 * no-op: nothing to mark, no reason to yank the reader elsewhere.
 * Callers must pass `isRead: true` when the row payload is unknown
 * (deep-linked document not on the current list page) — only documents
 * KNOWN to be unread get the mark-and-advance.
 * Failures are quiet — the action that brought us here (the attach)
 * already succeeded and said so; a failed courtesy must not read as a
 * failed volley.
 */
const useInboxProcessed = (documentId, isRead) => {
  const markReviewed = useMarkInboxReviewed();

  return useCallback(() => {
    if (!documentId || isRead) return;
    markReviewed(documentId).catch(() => {});
  }, [documentId, isRead, markReviewed]);
};

export default useInboxProcessed;
